import { nanoid } from 'nanoid';
import { useEffect, useState } from 'react';
import {
    Modal,
    Box,
    Typography,
    Divider,
    Table,
    TableBody,
    TableContainer,
    TableRow,
    TableCell,
    TableHead,
    IconButton
} from '@mui/material';
import { getFiles, getFile, deleteFile } from 'services/documents';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import CloseIcon from '@mui/icons-material/Close';
import { enqueueSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

const DocumentFiles = ({ openModal, handleCloseModal, documentSelected, typeDocumentSelected, reloadDocuments }) => {
    const [files, setFiles] = useState([]);

    const user = useSelector((state) => state.auth.user);
    const onlyView = user.perfil_id === 4;

    const handleClose = () => {
        handleCloseModal();
        setFiles([]);
    };

    const fetchData = async () => {
        if (documentSelected.id) {
            const res = await getFiles(documentSelected.id);
            setFiles(res.data);
        }
    };

    useEffect(() => {
        if (openModal) fetchData();
    }, [openModal]); // eslint-disable-line

    const formatDate = (date) => {
        let time = new Date(date);
        return time.toLocaleString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    return (
        <Modal open={openModal} onClose={handleClose} aria-labelledby="modal-title" aria-describedby="modal-description">
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    minWidth: 400,
                    maxWidth: 600,
                    boxShadow: 24,
                    p: 2,
                    borderRadius: '20px'
                }}
            >
                <Typography id="modal-title" variant="h3" component="h2" mb={2}>
                    {typeDocumentSelected?.nome}
                    <CloseIcon style={{ float: 'right', cursor: 'pointer', color: 'gray' }} onClick={handleClose} />
                </Typography>
                <Divider />
                <TableContainer sx={{ maxHeight: 500, overflowY: 'scroll' }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell style={{ fontSize: 14 }}>Enviado</TableCell>
                                <TableCell style={{ fontSize: 14 }}>Validado</TableCell>
                                <TableCell style={{ fontSize: 14 }}>Baixar</TableCell>
                                <TableCell style={{ fontSize: 14 }}>Excluir</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {files.map((file) => (
                                <TableRow key={nanoid()}>
                                    <TableCell style={{ fontSize: 12 }}>{formatDate(file.created_at)}</TableCell>
                                    <TableCell style={{ fontSize: 12 }}>
                                        {file.validated_at ? formatDate(file.validated_at) : 'Não validado'}
                                    </TableCell>
                                    <TableCell>
                                        <IconButton
                                            color="primary"
                                            size="small"
                                            onClick={async () => {
                                                getFile(file.id, documentSelected.id).then((resp) => {
                                                    const url = window.URL.createObjectURL(
                                                        new Blob([resp.data], { type: 'application/pdf' })
                                                    );
                                                    window.open(url, '_blank');
                                                    window.URL.revokeObjectURL(url);
                                                });
                                            }}
                                        >
                                            <DownloadIcon />
                                        </IconButton>
                                    </TableCell>
                                    <TableCell>
                                        <IconButton
                                            disabled={file.validated_at !== null || onlyView}
                                            color="error"
                                            size="small"
                                            onClick={async () => {
                                                if (confirm('Deseja realmente excluir este arquivo?')) {
                                                    await deleteFile(file.id, documentSelected.id);
                                                    enqueueSnackbar('Arquivo excluído com sucesso!', { variant: 'success' });
                                                    reloadDocuments();
                                                    fetchData();
                                                }
                                            }}
                                        >
                                            <DeleteIcon style={{ fontSize: 20 }} />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                            {files.length == 0 && (
                                <TableRow>
                                    <TableCell colSpan={4} style={{ textAlign: 'center' }}>
                                        <Typography variant="p" style={{ fontSize: 14 }}>
                                            Nenhum arquivo anexado
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </Modal>
    );
};

DocumentFiles.propTypes = {
    openModal: PropTypes.bool,
    handleCloseModal: PropTypes.func,
    documentSelected: PropTypes.object,
    typeDocumentSelected: PropTypes.object,
    reloadDocuments: PropTypes.func
};

export default DocumentFiles;
